import { useTheme } from "@mui/material";
import Box from "@mui/material/Box"
import useChatClient from "../../hooks/useChatClient";
import { useEffect } from "react";
import FallbackSpinner from "../../../../materio/@core/components/spinner";
import ConversationSummary from "./ConversationSummary";
import ChatBotSummary from "./ChatBotSummary";
import StatusFilter from "./StatusFilter";

const ChatSidebarLeft = () => {
    const theme = useTheme();
    const {
        conversations,
        errorLoadingChats,
        loadingConversations,
        loadChats,
        setSelectedConversation,
        status
    } = useChatClient();

    useEffect(() => {
        loadChats();
    }, [status])

    if (loadingConversations) return <FallbackSpinner />

    return (
        <Box sx={{ backgroundColor: theme.palette.background.paper, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} width={420} borderRadius={2} padding={5}>
            <Box>
                <Box>
                    <StatusFilter />
                </Box>
                {conversations.map(cn => <ConversationSummary cn={cn} />)}
            </Box>
            <ChatBotSummary />
            {errorLoadingChats && <Box>Error Loading Conversations</Box>}
        </Box>
    )
}

export default ChatSidebarLeft;